/**
 * IndexedDB blob store for offline result-sheet photos.
 * Small wrapper — no dependencies. Falls back to no-op if IDB unavailable.
 */
const DB_NAME = "bw_photos";
const STORE = "photos";
const DB_VERSION = 1;

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") return reject(new Error("IndexedDB unavailable"));
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(mode, fn) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const store = t.objectStore(STORE);
    const p = fn(store);
    t.oncomplete = () => resolve(p);
    t.onerror = () => reject(t.error);
    t.onabort = () => reject(t.error);
  });
}

export async function putPhoto(key, file) {
  await tx("readwrite", (s) => s.put({ blob: file, name: file.name, type: file.type, size: file.size }, key));
  return key;
}

export async function getPhoto(key) {
  return new Promise(async (resolve, reject) => {
    try {
      const db = await openDb();
      const t = db.transaction(STORE, "readonly");
      const req = t.objectStore(STORE).get(key);
      req.onsuccess = () => resolve(req.result || null);
      req.onerror = () => reject(req.error);
    } catch (e) { reject(e); }
  });
}

export async function deletePhoto(key) {
  await tx("readwrite", (s) => s.delete(key));
}

export async function photoObjectUrl(key) {
  const rec = await getPhoto(key);
  if (!rec) return null;
  return URL.createObjectURL(rec.blob);
}
